<mat-toolbar class="toolbar dark">
    <div class="toolbar-background">
        <div class="top-nav">
            <div class="menu-wrapper">
                <button mat-icon-button (click)="menuClicked()">
                    <mat-icon>menu</mat-icon>
                </button>
                @if (platform.name === "Lytehouse") {
                    <img src="logos/wordmark.webp" alt="">
                }
                @if(platform.name === "Littlefish") {
                    <img src="logos/littlefish_white.png" alt="">
                }
            </div>
            <div class="profile-container">
                <lh-experimental-wrapper>
                    <mat-chip-set exp>
                        <mat-chip>
                            <mat-icon matChipAvatar>science</mat-icon>
                            Alpha
                        </mat-chip>
                    </mat-chip-set>
                </lh-experimental-wrapper>
                <button
                    mat-icon-button
                    aria-label="Open Notifications Menu"
                    (click)="openAlerts()"
                    [class.has-notifications]="hasNotifications">
                    <mat-icon>notifications</mat-icon>
                    @if (hasNotifications) {
                        <span class="notification-indicator"></span>
                    }
                </button>
                <p>Hi, {{user()?.name}}</p>
                <button class="profile-button" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Open Profile Menu">
                    <mat-icon>person</mat-icon>
                </button>
            </div>
        </div>
    </div>
</mat-toolbar>

<mat-menu #menu="matMenu">
    @if (colourMode === 1) {
    <button mat-menu-item (click)="toggleColourMode(2)">
        <mat-icon>dark_mode</mat-icon>
        <span>Dark Mode</span>
    </button>
    } @else {
    <button mat-menu-item (click)="toggleColourMode(1)">
        <mat-icon>light_mode</mat-icon>
        <span>Light Mode</span>
    </button>
    }
    <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
    </button>
    <mat-divider></mat-divider>
    <div class="build-version">
        <small>{{buildVersion}}</small>
    </div>
</mat-menu>
